const hue2rgb = (p, q, t) => {
  let tt = t;
  if (tt < 0) tt += 1;
  if (tt > 1) tt -= 1;
  if (tt < 1 / 6) return p + ((q - p) * 6 * tt);
  if (tt < 1 / 2) return q;
  if (tt < 2 / 3) return p + ((q - p) * ((2 / 3) - tt) * 6);
  return p;
};

const hslToRgb = (h, s, l) => {
  let r;
  let g;
  let b;

  if (s === 0) { // achromatic
    r = l;
    g = l;
    b = l;
  } else {
    const q = l < 0.5 ? l * (1 + s) : (l + s) - (l * s);
    const p = (2 * l) - q;
    r = hue2rgb(p, q, h + (1 / 3));
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - (1 / 3));
  }

  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255),
  };
};

const hslToWeb = (h, s = 0.75, l = 0.65) => {
  const color = hslToRgb(h, s, l);
  return `rgb(${color.r},${color.g},${color.b})`;
};

export default {
  hue2rgb,
  hslToRgb,
  hslToWeb,
};



// WEBPACK FOOTER //
// ./src/utils/hsl.js